import { Injectable } from '@angular/core';
import { Renseignements } from '../../models/Renseignements';

@Injectable({
  providedIn: 'root'
})
export class RenseignementsService {

  constructor() {
  }

  getRenseignements(controls) {
    const renseignements = new Renseignements();
    renseignements.idMarche = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Renseignements_SepAtt_idMarche'));
    renseignements.rensgComplt = this.sanitizeString(controls.get('_SepSep_Initial_SepSep_Renseignements_SepAtt_rensgComplt'));
    return renseignements;
  }

  private sanitizeString(value: any): string | null {
    if (typeof value !== 'string') {
      return value;
    }
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : null;
  }
}
